import merge from "lodash.merge";

class Config {
    constructor(initData) {
        this.copyFrom(initData);
    }

    copyFrom(data) {
        if (!data || typeof data !== 'object') {
            return;
        }

        merge(this, data);

        return this;
    }

    loadConfig() {
        return new Promise((resolve, reject) => {
            fetch(this.defines.CONFIG_URL + this.defines.CONFIG_FILE, { options: { timeout: 10000 } })
                .then(response => response.json())
                .then((response) => {
                    this.copyFrom(response);
                    resolve();
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Config;